import { useMediaQuery } from '@lumapps/utils/hooks/useMediaQuery';

export const usePrefersReducedMotion = () => {
    return useMediaQuery({ query: '(prefers-reduced-motion: reduce)' });
};
